import { AddRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import {
  Autocomplete,
  createFilterOptions,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
const filter = createFilterOptions();

export default function InputAuto(props) {
  const {
    name,
    label,
    value,
    variant,
    size,
    onChange,
    onInput,
    options = [],
    error = null,
    required,
    placeholder,
    enableAddBtn = false,
    handleAdd,
    disableClearable = true,
    noFilter = false,
    loading = false,
    ...other
  } = props;
  const [val, setVal] = useState(null);

  useEffect(() => {
    setVal(options.find((j) => j.id === value));
  }, [options, value]);

  const handleChange = (even, newVal) => {
    if (newVal && newVal.inputValue) handleAdd(newVal.inputValue);
    else {
      setVal(newVal);
      var e = {
        target: {
          value: newVal ? newVal.id : "",
          name: name,
        },
      };
      onChange && onChange(e, newVal);
    }
  };

  const handleInpChg = (even, newVal, reason) => {
    if (!newVal) {
      setVal(null);
      handleChange(null, newVal);
    }
    onInput && onInput(even, newVal, reason);
  };

  const handleFilterOpt = (opt, params) => {
    const filtered = noFilter ? [...opt] : filter(options, params);
    if (enableAddBtn && params.inputValue !== "") {
      filtered.push({
        inputValue: params.inputValue,
        label: (
          <div className="text-red-500 flex gap-2 items-center primary-color fs-[18px]">
            <AddRounded className="!text-[20px]" /> Add{" "}
            <span className="font-medium">"{params.inputValue}"</span>
          </div>
        ),
      });
    }
    return filtered;
  };

  return (
    <Autocomplete
      disableClearable={disableClearable}
      autoHighlight
      loading={loading}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      options={options}
      value={val || null}
      size={size || "small"}
      onChange={handleChange}
      onInputChange={handleInpChg}
      {...other}
      getOptionLabel={(opt) => {
        if (typeof opt === "string" || opt.inputValue) return "";
        return `${opt.label}${
          opt.subtitle && opt.subtitle.trim() !== "" ? ` (${opt.subtitle})` : ""
        }`;
      }}
      filterOptions={handleFilterOpt}
      renderOption={(prop, opt) => (
        <ListItemButton
          {...prop}
          key={`${opt.id}-${opt.label}`}
          sx={{
            p: 0,
            mb: "2px",
            minHeight: "auto",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <ListItemText
            primaryTypographyProps={{
              fontSize: "14px",
              color: "#333",
            }}
            secondaryTypographyProps={{
              fontSize: "12px",
              color: "#777",
            }}
            sx={{ m: 0 }}
            primary={opt.label}
            secondary={opt.subtitle}
          />
        </ListItemButton>
      )}
      componentsProps={{
        paper: {
          className: "border border-gray-500 !rounded-[10px]",
        },
      }}
      popupIcon={<KeyboardArrowDownRounded />}
      renderInput={(params) => (
        <TextField
          variant={variant || "outlined"}
          label={label}
          required={required}
          placeholder={placeholder}
          {...params}
          {...(error && { error: true, helperText: error })}
        />
      )}
    />
  );
}
